export const EDIT_AUTH = 'EDIT_AUTH'